import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DatePicker from "react-datepicker";
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { addDays,addMonths } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";

import { ANY_ERROR } from '../../../action/user_action_types';
import http from '../../../util/http';

class ExcelPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      campaignData: []
    }
  }

  handleStartDate = startDate => {
    let { endDate } = this.state;
    if (endDate && endDate < startDate) {
      return this.props.showError("End date an not less then start Date!")
    }
    this.setState({ startDate });
  }

  handleLastDate = endDate => {
    let { startDate } = this.state;
    if (startDate && startDate > endDate) {
      return this.props.showError("Start date can not be grater then End date!")
    }
    this.setState({ endDate });
  }

  generateExcel = async (event) => {
    event.preventDefault();
    let { startDate, endDate } = this.state;
    if (!startDate || !endDate) {
      return this.props.showError("Start date and End date is required!")
    }
    console.log(new Date(startDate));
    let fromDate = new Date();
    var f = new Date(startDate);
    var e = new Date(endDate);
    f.setHours(0);
    console.log(f);
    e.setHours(23);
    console.log(e);
    let query = `startDate=${f.getTime()}&endDate=${e.getTime()}`;
    let url = `/admin/generate-campaign-excel?${query}`;
    let response = await http.get(url);
    if (response && response.data.statusCode == 200) {
      this.formatXls(response.data.data);
      this.props.hideExcelPopup();
    }
    else {
      this.props.showError(response.data.message);
      this.props.hideExcelPopup();
    }
  }

  formatXls= data=> {
    let campaignData= [];
    console.log('Excel data', data);
    data.map((campaign, index)=> {
      let obj= Object.assign({}, campaign, {
        s_no: index+1,
        createdAt: moment(campaign.createdAt).format("DD-MM-YYYY"),
        startDate: moment(campaign.startDate).format("DD-MM-YYYY"),
        BigFM_Audio: campaign.bigFmAudio=== "true"? "YES": "NO",
        fileName: campaign.fileName ? campaign.name.trim()+'_'+moment(campaign.createdAt).format("DD-MM-YYYY")+'_'+campaign.station.trim()+'_'+campaign._id+'_'+campaign.fileName : "",
        customerName: campaign.userDetails? campaign.userDetails[0].name: '',
        customerMobile: campaign.userDetails? campaign.userDetails[0].mobile: '',
        customerCompany: campaign.userDetails? campaign.userDetails[0].company: '',
        customerPan: campaign.kycDetails && campaign.kycDetails[0]? campaign.kycDetails[0].pan_number:'',
        customerTan: campaign.kycDetails&& campaign.kycDetails[0]? campaign.kycDetails[0].tan_number:'',
        customerGST: campaign.kycDetails && campaign.kycDetails[0]? campaign.kycDetails[0].gst_Number:'',
        paidAmount: campaign.pendingAmount ? Math.round(campaign.pendingAmount - campaign.totalCost)>0 ? Math.round(campaign.pendingAmount - campaign.totalCost): Math.round(campaign.totalCost - campaign.pendingAmount): 0
      });
      campaignData.push(obj);
      console.log(campaignData);
    });
    this.setState({campaignData}, ()=> {
      this._exporter.save();
    });
  }

  render() {
    let { startDate, endDate, campaignData } = this.state;
    return (
      <div>
        <div className="modal-overlay">
          <div className="modal-wrapper thankyou-popup" aria-modal aria-hidden tabIndex={-1} role="dialog">
            <div className="modal">
              <div className="modal-head-cross rate-modal">
                <button type="button" className="modal-close-button" onClick={() => this.props.hideExcelPopup()}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">

                <div className="editNonFct-header modal-header" >
                  <h4 className="popup-head rqst-head fct-head modal-title">Select Date Range</h4></div>
                <div className="editNonFct-modal modal-body">
                  <div className="bg-white">
                    <form className="form-group">
                      <div className="popupCampaign-container">
                        <div className="campaign-input master-inputs nonFct">
                          <div className="input-tag signup-tag clearfix fct-input">
                            <label className="static-value date_label">Start Date</label>
                            <DatePicker selected={startDate} onChange={this.handleStartDate} maxDate={endDate} minDate={addDays(new Date(), -500)} />
                          </div>
                        </div>
                        <div className="campaign-input master-inputs nonFct">
                          <div className="input-tag signup-tag clearfix fct-input">
                            <label className="static-value date_label">End Date</label>
                            <DatePicker selected={endDate} onChange={this.handleLastDate} minDate={startDate}  maxDate={addDays(new Date(), 0)} />
                          </div>
                        </div>
                        <div className="create-camp nonfct-submit">
                          <button onClick={this.generateExcel}>DOWNLOAD</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ExcelExport
          data={campaignData}
          fileName="campaign.xlsx"
          ref={(exporter) => { this._exporter = exporter; }}
        >
          <ExcelExportColumn field="name" title="Campaign Name" />
          <ExcelExportColumn field="brand" title="Brand Name" />
          <ExcelExportColumn field="product" title="Product Category" />
          <ExcelExportColumn field="type" title="Package Type" />
          <ExcelExportColumn field="days" title="Days Count" />
          <ExcelExportColumn field="Created Date" title="createdAt" />
          <ExcelExportColumn field="startDate" title="Start Date" />
          <ExcelExportColumn field="rotationPerDay" title="Rotation Per Day" />
          <ExcelExportColumn field="station" title="Station" />
          <ExcelExportColumn field="audioDuration" title="Audio Duration" />
          <ExcelExportColumn field="objective" title="Objective" />
          <ExcelExportColumn field="fileName" title="Filename" />
          <ExcelExportColumn field="BigFM_Audio" title="BigFM Audio" />
            <ExcelExportColumn field = "totalCost" title="Total Amount"/>
            <ExcelExportColumn field = "paidAmount" title="Received Amount"/>
            <ExcelExportColumn field = "pendingAmount" title="Pending Amount"/>
            <ExcelExportColumn field="customerName" title="Customer Name" />
            <ExcelExportColumn field="customerMobile" title="Mobile" />
            <ExcelExportColumn field="customerCompany" title="Company" />
            <ExcelExportColumn field="customerPan" title="PAN Number" />
            <ExcelExportColumn field="customerTan" title="TAN Number" />
            <ExcelExportColumn field="customerGST" title="GST Number" />


          {/* <ExcelExportColumn field="userEmail" title="userEmail" />
          <ExcelExportColumn field="userName" title="userName" />
          <ExcelExportColumn field="userMobile" title="userMobile" />
          <ExcelExportColumn field="userCompany" title="userCompany" />
          <ExcelExportColumn field="userIndustry" title="userIndustry" />
          <ExcelExportColumn field="userState" title="userState" /> */}


        </ExcelExport>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showError: error => dispatch({
      type: ANY_ERROR,
      payload: error
    })
  }
}

export default connect(null, mapDispatchToProps)(ExcelPopup);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/ExcelPopup.jsx